// Centralised copy + content for the Stoyga "Monolith & Void" landing page.

export const NAV_LINKS = [
  { label: "Studio", href: "#about" },
  { label: "Titles", href: "#archive" },
  { label: "Contact", href: "#contact" },
];

export const FOCUS = "Long-Form Documentary Features";

export const PROJECTS = [
  {
    title: "Piano Fingers",
    category: "Feature Documentary",
    status: "In Post-Production",
    logline:
      "A feature documentary in which director Megha Bhaduri turns the camera on her own family to understand a daunting future, and what it means to keep choosing life anyway.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nonfiction-stage/artifacts/jwpw63pg_Screenshot%202026-08-12%20at%2010.19.54%E2%80%AFAM.png",
  },
  {
    title: "Dragons in a Mountain Pond",
    category: "Feature Documentary",
    status: "In Development",
    logline:
      "A rare, legally protected salamander returns each year to breed in vanishing Himalayan wetlands — and one conservationist's quiet obsession grows into a movement to prove that people and nature don't have to be enemies.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nonfiction-stage/artifacts/a2ni4kba_Screenshot%202026-08-12%20at%2010.04.20%E2%80%AFAM.jpg",
  },
  {
    title: "In Between Rains",
    category: "Feature Documentary",
    status: "In Development",
    logline:
      "A family caught between a disappearing village and a city that never quite lets them belong, and one filmmaker's search for what home really means.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nonfiction-stage/artifacts/y9eylq47_WhatsApp%20Image%202026-08-04%20at%2017.34.49%20bw.jpg",
  },
];

export const CONTACT_EMAIL = "hello@stoyga.com";
export const STUDIO_LOCATION = "India, Italy";

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_nonfiction-stage/artifacts/0pphfeje_Screenshot%202026-07-30%20at%208.08.22%E2%80%AFPM.png";
